export { default as theme } from 'prism-themes/themes/prism-pojoaque.css';
